
import React, { useRef, useState } from "react";
import GenericDetailsPage from "../../../Domain/Components/Functional/GenericDetailsPage/GenericDetailsPage";
function CampaignDetailsPage(props) {

    return <><GenericDetailsPage setLoggedIn={props.setLoggedIn}
                            title={"Campaign Details"}
                            editHref={"/campaign/update"}
                            endpoint={"campaign/read"}
                            relations={["jackpots", "currency", "tenant"]}
                            displayIds={["provider_campaign_id"]}
                            oneToManyRelations={[
                                {
                                    title: "Jackpots",
                                    columnTitles: [
                                        "ID", "Name", "Provider Jackpot ID", "Type", "Contribution Percentage", "Value"
                                    ],
                                    name: "jackpots",
                                    objectKeys: ["id", "name", "provider_jackpot_id", "type", "contribution_percentage", "value"],
                                    
                                }
                            ]}
                            manyToManyRelations={[{
                                name: "tenant",
                                title: "Tenants",
                                attachHref: {
                                    href: "/campaign-tenant/create",
                                    title: "Attach Tenant"
                                },
                                columnTitles: ["Tenant", "External ID"],
                                objectKeys: ["name", "external_id"],
                                editHref: "/campaign-tenant/update",
                                detailsHref: "/campaign-tenant/details"
                            }]}/>
            </>
}

export default CampaignDetailsPage;